import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';
import * as React from 'react';
import {TextColor} from '../../../constants/generals';
import {IMenuItems} from '../../../interfaces';

export interface ISelectProps {
    hintText: string;
    menuItems: IMenuItems[];
    onChange: Function;
    multiple: boolean;
    color?: string;
    value: string[] | string;
    errorText?: string;
    disabled?: boolean;
}

export interface ISelectState {
    value: string;
}

export class Select extends React.PureComponent<ISelectProps, ISelectState> {
    constructor(props: ISelectProps) {
        super(props);
        this.state = {value: ''};
    }

    selectStyle: React.CSSProperties = {
        color: this.props.color
    };

    public render() {
        const {hintText, menuItems, multiple, value, errorText} = this.props;
        const labels = menuItems.map(item => item.label);
        const values = menuItems.map(item => item.value);
        return <SelectField
            value={value || this.state.value}
            labelStyle={this.selectStyle}
            hintText={hintText}
            multiple={multiple}
            errorText={errorText}
            disabled={this.props.disabled}
            className="select-input"
            selectedMenuItemStyle={{color: TextColor}}
            onChange={(event, key, selectedValues) => {
                const index = values.indexOf(selectedValues[selectedValues.length - 1]);
                this.props.onChange(event, selectedValues, labels[index]);
            }}
        >
            {(menuItems || []).map((item, index) => {
                return <MenuItem key={index} value={item.value} primaryText={item.label}/>;
            })}
        </SelectField>;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/reusableComponents/FormComponents/Select.tsx